import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import cloudBackupImg1 from '../../../../assets/services/disaster/ManagedBackup/disaster.png'; // Adjust path as needed

const DisasterSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Rapid and Simple Disaster Recovery Service</h1>
          <p>
            This solution is capable of securely spinning up full production environments in minutes with no extra hardware. A Single portal covers backup and DR with multi-cloud failover, so service providers meet strict SLAs without breaking the budget. failover to a clean recovery point and stop ransomware reinfection. You can use various cloud failover targets. Easily manage recovery infrastructure in on-prem or in a hybrid setup. You can effortlessly automate runbooks, testing, and failover to the Disaster Recovery Cloud during a DR event.
          </p>
        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={cloudBackupImg1} alt="Cloud Backup Illustration" />
        </div>
      </div>
    </section>
  );
};

export default DisasterSection;
